<script setup>
import SelectTranslation from "./SelectTranslation.vue";
import { computed, inject } from "vue";

import stLogo from "../assets/logo.svg";

const brandingTheme = inject("brandingTheme");
const hideHeader = inject("noHeader");

const mainLogo = computed(() => (brandingTheme.value?.logo ? brandingTheme.value.logo : stLogo));
</script>

<template>
<div v-if="!hideHeader" class="relative z-[99] flex h-[42px] items-center justify-between bg-[var(--background)] px-3 py-0">
  <img :src="mainLogo" class="max-h-9 max-w-32" width="auto" height="36" alt="Scantrust Logo" crossorigin />
  <SelectTranslation />
</div>
</template>
